import { render, staticRenderFns } from "./TableListClients.vue?vue&type=template&id=17cde3f3&scoped=true&"
import script from "./TableListClients.vue?vue&type=script&lang=js&"
export * from "./TableListClients.vue?vue&type=script&lang=js&"
import style0 from "./TableListClients.vue?vue&type=style&index=0&id=17cde3f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cde3f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17cde3f3')) {
      api.createRecord('17cde3f3', component.options)
    } else {
      api.reload('17cde3f3', component.options)
    }
    module.hot.accept("./TableListClients.vue?vue&type=template&id=17cde3f3&scoped=true&", function () {
      api.rerender('17cde3f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/customers/TableListClients.vue"
export default component.exports